import type { ComponentPropsWithoutRef } from "react";

export const AssistantMarkdownTable = ({ children, ...tableProps }: ComponentPropsWithoutRef<"table">) => (
  <div role="region" aria-label="Assistant answer table" tabIndex={0} style={{ overflowX: "auto", maxWidth: "100%", margin: "8px 0" }}>
    <table {...tableProps} style={{ borderCollapse: "collapse", minWidth: "100%", ...tableProps.style }}>
      {children}
    </table>
  </div>
);
